import { TimelineComponent } from './timeline.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TimelineItemComponent } from './timeline-item/timeline-item.component';

@NgModule({
  declarations: [TimelineComponent, TimelineItemComponent],
  imports: [CommonModule],
  exports: [TimelineComponent, TimelineItemComponent],
})
export class TimelineModule {}
